import { render, staticRenderFns } from "./formDetails.vue?vue&type=template&id=404b515b&scoped=true"
import script from "./formDetails.vue?vue&type=script&lang=js"
export * from "./formDetails.vue?vue&type=script&lang=js"
import style0 from "./formDetails.vue?vue&type=style&index=0&id=404b515b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b515b",
  null
  
)

export default component.exports